/* ═══════════════════════════════════════════════════════════════════════
   HASIL GENERATE TERTINGGAL — peraturan tulen (tiada Firestore / React)
   (2026-10-26, arahan user: "user boleh Generate kad seterusnya tanpa tunggu
   pipeline siap; keluar page tak boleh buat pipeline gagal")

   Server kini menyimpan setiap Generate dalam
   users/{uid}/generation_progress/{progressId}:
     • semasa berjalan : { phase, detail, stepIndex, totalSteps, hasImage, productId, updatedAt }
     • bila siap       : { phase:'complete', productId, siapAtMs, hasilJson | hasilTerlaluBesar | hasilKosong }
     • bila gagal      : { phase:'error', productId, siapAtMs, ralat, kod }
   Page yang memulakan Generate dan masih terbuka mengambil hasil terus (laluan
   lama) dan memadam doc. Doc yang TERTINGGAL (page ditutup / dimuat semula /
   ke page lain) diambil oleh Workspace bila dibuka semula.

   ⚠️ KEMBAR: bentuk doc ditulis oleh functions/hasilGenerate.js (server).
   ═══════════════════════════════════════════════════════════════════════ */

/** Tiada kemas kini selama ini semasa "berjalan" = function sudah mati (had function 300s + had client 5 min). */
export const TEMPOH_MATI_MS = 8 * 60 * 1000;
/** Doc lebih tua dari ini dibuang terus (pelanggan tidak kembali dalam sehari). */
export const TEMPOH_BUANG_MS = 24 * 60 * 60 * 1000;
/** Doc lama format (sebelum 26 Okt, tiada productId) — server lama memadamnya sendiri selepas 3s. */
export const TEMPOH_FORMAT_LAMA_MS = 10 * 60 * 1000;
/** Doc siap diberi masa ini kepada page yang memulakannya (mungkin tab / profil lain yang masih terbuka)
 *  untuk mengambilnya sendiri, sebelum page ini mengambil alih. Elak dua page menulis kad yang sama. */
export const TUNGGU_PEMILIK_MS = 6000;

const masaDoc = (data) => {
    const ts = data?.updatedAt;
    if (ts && typeof ts.toMillis === 'function') return ts.toMillis();
    if (typeof data?.siapAtMs === 'number') return data.siapAtMs;
    return null;
};

/**
 * Kelaskan satu doc progress.
 * @returns {'abaikan'|'buang'|'jalan'|'mati'|'siap'|'siapTanpaHasil'|'ralat'}
 */
export function kelasDocProgress(data, sekarangMs = Date.now()) {
    if (!data || typeof data !== 'object') return 'abaikan';
    const masa = masaDoc(data);
    const umur = masa == null ? 0 : sekarangMs - masa;
    if (masa != null && umur > TEMPOH_BUANG_MS) return 'buang';

    const fasaAkhir = data.phase === 'complete' || data.phase === 'error';
    if (!data.productId || typeof data.productId !== 'string') {
        return (fasaAkhir || umur > TEMPOH_FORMAT_LAMA_MS) ? 'buang' : 'abaikan';
    }
    if (data.phase === 'complete') {
        return (typeof data.hasilJson === 'string' && data.hasilJson) ? 'siap' : 'siapTanpaHasil';
    }
    if (data.phase === 'error') return 'ralat';
    if (masa != null && umur > TEMPOH_MATI_MS) return 'mati';
    return 'jalan';
}

/** Berapa lama lagi perlu tunggu sebelum page ini mengambil doc siap. */
export function bakiTungguPemilik(data, sekarangMs = Date.now()) {
    const siap = typeof data?.siapAtMs === 'number' ? data.siapAtMs : sekarangMs;
    return Math.max(0, TUNGGU_PEMILIK_MS - (sekarangMs - siap));
}

/** Baca hasilJson. Rosak → null (pemanggil tanda kad gagal, jangan tulis kad separuh). */
export function bacaHasil(data) {
    try {
        const hasil = JSON.parse(data?.hasilJson || 'null');
        return (hasil && typeof hasil === 'object' && !Array.isArray(hasil)) ? hasil : null;
    } catch {
        return null;
    }
}

/** Kunci perubahan status berjalan — elak menulis state yang sama berulang kali. */
export function kunciStatus(data) {
    const masa = masaDoc(data);
    return `${data?.phase || ''}|${data?.stepIndex || 0}|${masa || ''}|${data?.detail || ''}`;
}
